import { render, staticRenderFns } from "./Vegetable.vue?vue&type=template&id=bd33c0c6&scoped=true&"
import script from "./Vegetable.vue?vue&type=script&lang=js&"
export * from "./Vegetable.vue?vue&type=script&lang=js&"
import style0 from "./Vegetable.vue?vue&type=style&index=0&id=bd33c0c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd33c0c6",
  null
  
)

export default component.exports